import React, { useEffect, useRef, useState } from "react";
import EditIcon from "@mui/icons-material/EditRounded";
import ArrowBackIcon from "@mui/icons-material/ArrowBackRounded";
import deviceProfile from "images/device.png";
import TranslationSettingsTab from "./Tabs/tanslationSettings";

function MyProfile({ onBackClick }) {
    const fileInputRef = useRef(null);

    const [userInfo, setUserInfo] = useState(null);
    const [showUpdateAvatarModal, setShowUpdateAvatarModal] = useState(false);
    const [selectedImageFile, setSelectedImageFile] = useState(null);

    useEffect(() => {
        const storedUserInfo = localStorage.getItem("userInfo");
        if (storedUserInfo) {
            try {
                const parsedUserInfo = JSON.parse(storedUserInfo);
                setUserInfo(parsedUserInfo);
            } catch (error) {
                console.error("Error parsing userInfo:", error);
                localStorage.removeItem("userInfo");
            }
        }
    }, []);

    const handlePhotoEdit = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedImageFile(file);
            setShowUpdateAvatarModal(true);
        }
    };

    const handleCancelAvatar = () => {
        setShowUpdateAvatarModal(false);
        setSelectedImageFile(null);

        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    };

    const handleConfirmAvatarUpdate = async () => {
        if (selectedImageFile) {
            console.log("selectedImageFile: ", selectedImageFile);
            // if (result.success) {
            //     toast.success(result.message);
            // } else {
            //     toast.error(result.error);
            // }
        }

        setShowUpdateAvatarModal(false);
        setSelectedImageFile(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    };

    return (
        <div className="midde_cont">
            <div
                className="container-fluid"
                style={{ paddingLeft: "0", paddingRight: "0" }}
            >
                <div className="row column_title">
                    <div className="col-md-12">
                        <div className="page_title" style={{ display: "flex", alignItems: "center" }}>
                            {onBackClick && (
                                <button
                                    onClick={onBackClick}
                                    style={{
                                        background: "none",
                                        border: "none",
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        padding: "8px",
                                        marginRight: "10px",
                                        borderRadius: "4px",
                                        transition: "background-color 0.2s"
                                    }}
                                    
                                >
                                    <ArrowBackIcon sx={{ fontSize: "1.5rem", color: "#333" }} />
                                </button>
                            )}
                            <h2 style={{ flex: "1", margin: "0" }}>{userInfo?.name}'s Profile</h2>
                        </div>
                    </div>
                </div>
                <div className="white_shd full margin_bottom_30" style={{ paddingLeft: "10px", paddingRight: "10px" }}>
                    <div style={{ display: "flex", marginTop: "40px", marginLeft: "40px" }}>
                        {/* <div style={{ position: "relative" }}>
                            {userInfo?.profilePicture ? (
                                <img
                                    style={{
                                        borderRadius: "50%",
                                        width: "150px",
                                        height: "150px",
                                        objectFit: "cover",
                                    }}
                                    src={`data:image/png;base64, ${userInfo?.profilePicture}`}
                                    alt={userInfo?.name}
                                />
                            ) : (
                                <img
                                    style={{
                                        borderRadius: "50%",
                                        width: "150px",
                                        height: "150px",
                                        objectFit: "cover",
                                    }}
                                    src={deviceProfile}
                                    alt="Default profile"
                                />
                            )}
                            <div onClick={() => handlePhotoEdit()}
                                style={{
                                    position: "absolute",
                                    right: "5px",
                                    bottom: "20px",
                                    cursor: "pointer",
                                    background: "#fff",
                                    borderRadius: "50%",
                                    padding: "5px",
                                    width: "30px",
                                    height: "30px",
                                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                }}
                            >
                                <EditIcon sx={{ fontSize: "1.2rem", color: "black" }} />
                            </div>
                            <input
                                type="file"
                                ref={fileInputRef}
                                onChange={handleFileChange}
                                style={{ display: "none" }}
                                accept="image/*"
                            />
                        </div> */}

                        <div
                            style={{
                                marginLeft: "12px",
                                marginTop: "60px",
                                marginBottom: "30px",
                                display: "flex",
                                flexDirection: "column",
                                gap: "20px",
                            }}
                        >
                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                <h2 style={{ margin: 0 }}>{userInfo?.name}</h2>
                            </div>
                            <div
                                style={{
                                    display: "grid",
                                    gridTemplateColumns: "auto minmax(200px, 1fr) auto",
                                    alignItems: "center",
                                    width: "100%",
                                    gap: "20px",
                                }}
                            >
                                <p
                                    style={{
                                        fontWeight: "500",
                                        fontSize: "18px",
                                        color: "black",
                                        margin: 0,
                                        gridColumn: "1",
                                    }}
                                >
                                    Email: {userInfo?.email}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="full inner_elements">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="tab_style1">
                                    <div className="tabbar padding_infor_info" style={{ display: "block", paddingTop: "25px" }}>
                                        <nav>
                                            <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                                <div
                                                    className={`nav-item nav-link  active`}
                                                    id="nav-workerhitory-tab"
                                                    data-toggle="tab"
                                                    href="#nav-workerhitory"
                                                    role="tab"
                                                    aria-controls="nav-workerhitory"
                                                    aria-selected="true"
                                                >
                                                    Translation Settings
                                                </div>
                                            </div>
                                        </nav>

                                        <div className="tab-content" id="nav-tabContent">
                                            <div
                                                className={`tab-pane fade show active`}
                                                id="nav-workerhitory"
                                                role="tabpanel"
                                                aria-labelledby="nav-workerhitory-tab"
                                            >
                                                <TranslationSettingsTab />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Open modal for updating avatar */}
                {showUpdateAvatarModal && (
                    <div className="modal" role="dialog">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content" style={{ width: "400px" }}>
                                <div className="modal-header">
                                    <h1 className="modal-title">Update Profile Picture</h1>
                                    <button className="close-button" onClick={handleCancelAvatar}>
                                        &times;
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <p>Are you sure you want to update the profile picture?</p>
                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn cur-p btn-secondary"
                                        onClick={handleCancelAvatar}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="button"
                                        className="btn cur-p btn-primary"
                                        onClick={handleConfirmAvatarUpdate}
                                    >
                                        Update
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default MyProfile;